import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H3 from 'UIComponents/elements/headings/H3';
import UITourCancelButton from 'ui-shepherd-react/button/UITourCancelButton';
import { useTourTrackingMethod } from 'ui-shepherd-react/contexts/TourTrackingContext';
import { EVENTS } from '../../constants/TrackingConstants';
import { removeNextTourToStorage } from '../../util/tourStorage';
import { UsageTracker } from '../../util/usageTracker';

const trackCloseModal = (stepId, tourId, action) => {
  UsageTracker.track(EVENTS.TOUR_VIEW_CLOSE_MODAL, {
    action,
    tourId,
    stepId
  });
};

const OnboardingTourCloseModal = ({
  onConfirm,
  onReject,
  tourId,
  stepId
}) => {
  const trackTourViewCloseModal = useTourTrackingMethod('trackTourViewCloseModal');
  useEffect(() => {
    if (trackTourViewCloseModal) {
      trackTourViewCloseModal(tourId, stepId, 'open tour close modal');
      return;
    } // TODO: remove when tracking is fully migrated to ui-shepherd-react


    trackCloseModal(stepId, tourId, 'open tour close modal');
  }, [stepId, tourId, trackTourViewCloseModal]);
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboarding-tours-modal.close.title"
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      className: "p-top-6",
      children: [/*#__PURE__*/_jsx(UITourCancelButton, {
        onClick: () => {
          if (trackTourViewCloseModal) {
            trackTourViewCloseModal(tourId, stepId, 'confirm closing tour');
          } else {
            // TODO: remove when tracking is fully migrated to ui-shepherd-react
            trackCloseModal(stepId, tourId, 'confirm closing tour');
          }

          onConfirm();
          removeNextTourToStorage();
        },
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboarding-tours-modal.close.confirm"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: () => {
          if (trackTourViewCloseModal) {
            trackTourViewCloseModal(tourId, stepId, 'reject closing tour');
          } else {
            // TODO: remove when tracking is fully migrated to ui-shepherd-react
            trackCloseModal(stepId, tourId, 'reject closing tour');
          }

          onReject();
        },
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboarding-tours-modal.close.reject"
        })
      })]
    })]
  });
};

OnboardingTourCloseModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  stepId: PropTypes.string.isRequired,
  tourId: PropTypes.string.isRequired
};
export default OnboardingTourCloseModal;